import ApiClient from '../ApiClient';

class RcsChannel extends ApiClient {
  constructor() {
    super('channels/rcs_channels', { accountScoped: true });
  }
}

export default new RcsChannel();
